// src/client/screens/borrower/LoansListScreen.tsx
import { useLoansHistory } from '@client/hooks/useLoan';
import AppHeader from '@client/components/AppHeader';
import LoanCard from '@client/components/LoanCard';
import NavBar from '@client/components/NavBar';

export default function LoansListScreen() {
  const { data, isLoading, isError } = useLoansHistory();

  return (
    <div className="app-shell app-shell--with-nav">
      <AppHeader />

      <main className="scroll-area" style={{ padding: '0 16px 24px' }}>
        <h1 style={{ margin: '16px 0 20px', fontSize: 26, fontWeight: 800, color: 'var(--c-text)' }}>
          Loan History
        </h1>

        {isLoading && (
          <p className="small" style={{ color: 'var(--c-text-muted)', textAlign: 'center', padding: '40px 0' }}>
            Loading…
          </p>
        )}

        {isError && (
          <p className="small" role="status" style={{ color: 'var(--c-danger)', textAlign: 'center', padding: '40px 0' }}>
            Couldn&apos;t load your loans. Pull down to retry.
          </p>
        )}

        {data && data.length === 0 && (
          <div style={{
            background: '#ffffff',
            borderRadius: 16,
            border: '1px solid var(--c-border)',
            padding: '40px 24px',
            textAlign: 'center',
          }}>
            <p style={{ margin: 0, color: 'var(--c-text-muted)', fontSize: 15 }}>No loans yet</p>
          </div>
        )}

        {data && data.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {data.map((l) => <LoanCard key={l.id} loan={l} />)}
          </div>
        )}
      </main>

      <NavBar />
    </div>
  );
}
